import { render, staticRenderFns } from "./BALogoAdminSvg.vue?vue&type=template&id=395ad900&"
import script from "./BALogoAdminSvg.vue?vue&type=script&lang=ts&"
export * from "./BALogoAdminSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports